import { action, makeObservable, observable } from 'mobx';
import { DECISION_ACTION_TYPES_FOR_STORE } from '../enums/decisionTypes';
import { gameStore } from './gameStore';

const initialActiveHandInfo = {
  isHit: false,
  isStand: false,
  isSplit: false,
  isDouble: false,
  isSurrender: false,
  isInsurance: false,
  isWin: false,
  isLose: false,
  isBlackJack: false,
  isPush: false,
  isBust: false,
  isHandActive: false,
};

class RoundActiveHandStore {
  firstHandInfo = initialActiveHandInfo;

  secondHandInfo = initialActiveHandInfo;

  constructor() {
    makeObservable(this, {
      firstHandInfo: observable.deep,
      secondHandInfo: observable.deep,
      setHandInfo: action.bound,
      resetActiveHandInfo: action.bound,
    });
  }

  setHandInfo({ type, bool, changedProps, isSecondHand = false, isFirstHand }) {
    if ((gameStore.betId && !isSecondHand) || isFirstHand) {
      if (changedProps) {
        this.firstHandInfo = {
          ...this.firstHandInfo,
          ...changedProps,
        };
      } else {
        this.firstHandInfo = {
          ...this.firstHandInfo,
          [DECISION_ACTION_TYPES_FOR_STORE[type]]: bool,
        };
      }
    } else if (changedProps && gameStore.splitBetId) {
      this.secondHandInfo = {
        ...this.secondHandInfo,
        ...changedProps,
      };
    } else {
      this.secondHandInfo = {
        ...this.secondHandInfo,
        [DECISION_ACTION_TYPES_FOR_STORE[type]]: bool,
      };
    }
  }

  resetActiveHandInfo() {
    this.firstHandInfo = initialActiveHandInfo;
    this.secondHandInfo = initialActiveHandInfo;
  }
}

export const roundActiveHandStore = new RoundActiveHandStore();
